// 批量任务配置导出/导入的格式与校验逻辑（纯函数，便于单元测试）

// 当前配置文件格式版本
export const BATCH_CONFIG_VERSION = 1

// 导出文件名前缀（完整文件名: batch-config-YYYY-MM-DD.json）
export const BATCH_CONFIG_FILE_PREFIX = "batch-config"

function pad2(n) {
  return String(n).padStart(2, "0")
}

// 生成当前日期的文件名字符串，如 2026-08-22
export function todayDateString(date = new Date()) {
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`
}

// 构建 v1 快照对象
export function buildBatchConfigSnapshot({ tasks = [], accounts = [], configs = {}, requestInterval, name = "批量任务配置" } = {}) {
  return {
    version: BATCH_CONFIG_VERSION,
    name: name || "批量任务配置",
    exportedAt: new Date().toISOString(),
    tasks: Array.isArray(tasks) ? [...tasks] : [],
    accounts: Array.isArray(accounts) ? [...accounts] : [],
    configs: configs && typeof configs === "object" ? { ...configs } : {},
    requestInterval,
  }
}

// 解析并校验导入的配置文件内容
// 返回 { ok: true, data } 或 { ok: false, error }
export function parseBatchConfig(jsonText) {
  let parsed
  try {
    parsed = JSON.parse(jsonText)
  } catch (e) {
    return { ok: false, error: "文件不是有效的 JSON" }
  }

  if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
    return { ok: false, error: "配置文件格式不正确" }
  }

  if (parsed.version !== BATCH_CONFIG_VERSION) {
    return { ok: false, error: `不支持的配置版本: ${parsed.version}（当前支持 v${BATCH_CONFIG_VERSION}）` }
  }

  if (!Array.isArray(parsed.tasks)) {
    return { ok: false, error: "配置文件缺少任务列表（tasks）" }
  }
  if (!parsed.tasks.every((t) => typeof t === "string")) {
    return { ok: false, error: "任务列表（tasks）必须全部是任务 ID 字符串" }
  }

  const accounts = Array.isArray(parsed.accounts) ? parsed.accounts.filter((a) => typeof a === "string") : []
  const configs =
    parsed.configs && typeof parsed.configs === "object" && !Array.isArray(parsed.configs) ? { ...parsed.configs } : {}

  let requestInterval
  if (parsed.requestInterval !== undefined && parsed.requestInterval !== null) {
    const num = Number(parsed.requestInterval)
    if (!Number.isFinite(num) || num < 0) {
      return { ok: false, error: "请求间隔（requestInterval）必须是大于等于 0 的数字" }
    }
    requestInterval = Math.floor(num)
  }

  return {
    ok: true,
    data: {
      version: BATCH_CONFIG_VERSION,
      name: typeof parsed.name === "string" && parsed.name ? parsed.name : "批量任务配置",
      exportedAt: typeof parsed.exportedAt === "string" ? parsed.exportedAt : "",
      tasks: [...parsed.tasks],
      accounts,
      configs,
      requestInterval,
    },
  }
}
